// Chooses which chat widget to mount, app-wide, by who is logged in:
//   - logged-in PATIENT        -> patient clinical assistant (triage-capable,
//                                  authenticated, consent-gated). The chat is
//                                  the patient's front door.
//   - anonymous (logged out)   -> public Navigator on the landing/login pages.
//   - DOCTORS / SPECIALISTS / ADMIN / provider staff -> NO global floating
//                                  bubble. A doctor's front door is the patient
//                                  CASE, not a chat: the AI assistant is
//                                  case-scoped inside the Emergency workspace,
//                                  not a generic public navigator.
//
// Public navigator endpoint = VITE_CHAT_API (".../api/chat/"); the patient
// clinical assistant is the same base + "patient/".

import { useState } from 'react'

import WantokChat from './WantokChat'
import { useAuth } from '../auth/AuthProvider.jsx'
import { getAccessToken } from '../utils/storage.js'

const PUBLIC_CHAT_API = import.meta.env.VITE_CHAT_API
const PATIENT_CHAT_API = `${(PUBLIC_CHAT_API || '').replace(/\/+$/, '')}/patient/`

export default function GlobalChat() {
  const { user } = useAuth()
  const [consentAccepted, setConsentAccepted] = useState(false)

  const role = (user?.role || '').toLowerCase()

  // Logged-in patient -> clinical triage assistant.
  if (role === 'patient') {
    return (
      <WantokChat
        apiBase={PATIENT_CHAT_API}
        channel="patient"
        jwtToken={getAccessToken()}
        patientName={user?.full_name || user?.username || null}
        consentVersion="v1"
        consentAccepted={consentAccepted}
        onConsentRequired={() => setConsentAccepted(true)}
        bookUrl="/patient/book"
      />
    )
  }

  // Anonymous visitor (landing/login) -> public navigator chat.
  if (!user) {
    return <WantokChat apiBase={PUBLIC_CHAT_API} />
  }

  // Doctors / specialists / admin / provider staff -> NO global floating
  // bubble. Doctors get a case-scoped AI assistant inside the Emergency
  // workspace rather than a generic public "sign up" navigator.
  return null
}
